import { Action } from '@ngrx/store';
import { PointTypeModel } from '../../../_sdk/ems-devices/point-type.model';
import { ModelCollection } from '../../../_sdk/collection.model';

export const LOAD = 'POINT_TYPE_LOAD';
export const LOAD_COMPLETE = 'POINT_TYPE_LOAD_COMPLETE';

export const INSERT = 'POINT_TYPE_INSERT';
export const INSERT_COMPLETE = 'POINT_TYPE_INSERT_COMPLETE';

export const UPDATE = 'POINT_TYPE_UPDATE';
export const UPDATE_COMPLETE = 'POINT_TYPE_UPDATE_COMPLETE';

export const DELETE = 'POINT_TYPE_DELETE';
export const DELETE_COMPLETE = 'POINT_TYPE_DELETE_COMPLETE';

export const DISPOSE = 'POINT_TYPE_DISPOSE';

export class Load implements Action {
    public readonly type = LOAD;
}

export class LoadComplete implements Action {
    public readonly type = LOAD_COMPLETE;

    constructor(public payload: ModelCollection<PointTypeModel>) { }
}

export class Insert implements Action {
    public readonly type = INSERT;

    constructor(public payload: PointTypeModel) { }
}

export class InsertComplete implements Action {
    public readonly type = INSERT_COMPLETE;

    constructor(public payload: PointTypeModel) { }
}

export class Update implements Action {
    public readonly type = UPDATE;

    constructor(public payload: PointTypeModel) { }
}

export class UpdateComplete implements Action {
    public readonly type = UPDATE_COMPLETE;

    constructor(public payload: PointTypeModel) { }
}

export class Delete implements Action {
    public readonly type = DELETE;

    constructor(public payload: PointTypeModel) { }
}

export class DeleteComplete implements Action {
    public readonly type = DELETE_COMPLETE;

    constructor(public payload: PointTypeModel) { }
}

export class Dispose implements Action {
    public readonly type = DISPOSE;
}

export type Actions =
    Load | LoadComplete
    | Insert | InsertComplete
    | Update | UpdateComplete
    | Delete | DeleteComplete
    | Dispose;
